import React, { Component } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import redirectURL from "../redirectURL";
import 'react-datetime/css/react-datetime.css';
import Datetime from 'react-datetime';
import moment from 'moment';


var colors = ["#211C6A","#0593AA","#A98300","#944E63","#C81B23"];
class ConsignmentChart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      series: [],
      plannedcount: 0,
      unplannedcount: 0,
      pendingcount: 0,
      totalCount:0,
      noBreach: 0,
      oneToTwoDaysBreach: 0,
      threeToFiveDaysBreach: 0,
      sixToTenDaysBreach: 0,
      greaterTenDaysBreach: 0,
      basicTitle:'',
      basicType:'',
      overlay:'show-n',
      show:false,
      loadshow:"show-n",
      from_date: moment().format('DD-MM-YYYY'),
      end_date: moment().add(2, 'days').format('DD-MM-YYYY')
      // overspeed:0
    };
  }

  componentDidMount() {
    this.getdata(this.state.from_date, this.state.end_date);
  }

  getdata = (from_date, to_date) => {
    this.setState({
      loadshow: 'show-m'
    });

    // No need to redeclare from_date and to_date here.
    // Just work with the passed parameters or fallback to state.
    if (from_date === '' || from_date === undefined || to_date === '' || to_date === undefined) {
        from_date = this.state.from_date;
        to_date = this.state.end_date;
    }

    var params = {
        from_date: formatDate(from_date),
        to_date: formatDate(to_date),
    }


    redirectURL.post('/getpiechartforshipment', params).then((resp) => {
      var records = resp.data;

      // var noBreach = records.days_equal_to_zero;
      // var oneToTwoDaysBreach = records.days_more_than_one ;
      // var threeToFiveDaysBreach = records.days_more_than_three;
      // var sixToTenDaysBreach = records.days_more_than_six;
      // var greaterTenDaysBreach = records.days_more_than_ten;

      var noBreach = 2;
      var oneToTwoDaysBreach = 6;
      var threeToFiveDaysBreach = 7;
      var sixToTenDaysBreach = 3;
      var greaterTenDaysBreach =20;

      var total = noBreach+oneToTwoDaysBreach+threeToFiveDaysBreach+sixToTenDaysBreach+greaterTenDaysBreach;
    

      

      var data = [
        // {name: 'Total', y: total},
        { name: '0', y: noBreach },
        { name: '1-2 days', y: oneToTwoDaysBreach },
        { name: '3-5 days', y: threeToFiveDaysBreach },
        { name: '6-10 days', y: sixToTenDaysBreach },
        { name: '>10 days', y: greaterTenDaysBreach }
      ];

      this.setState({ 
        series: data,
        noBreach: noBreach,
        oneToTwoDaysBreach: oneToTwoDaysBreach,
        threeToFiveDaysBreach: threeToFiveDaysBreach,
        sixToTenDaysBreach: sixToTenDaysBreach,
        greaterTenDaysBreach: greaterTenDaysBreach,
        // totalCount:total
      }, () => {
          this.renderChart();
      }); 
    });
}

  componentDidUpdate() {
    this.renderChart();
  }

  renderChart = () => {
    // const totalCount = this.state.total.length;

    Highcharts.chart('container-c', {
      chart: {
        type: 'pie',
        width: 240,  // Adjust width to your desired size
        height: 240,
        margin: [0, 0, 0, 0], // This reduces extra space around the pie chart
      spacing: [10, 0, 0, 0],
        custom: {},
        events: {
          render: function() {
            const chart = this,
              series = chart.series[0];
            let customLabel = chart.customLabel;
            let customTotalLabel = chart.customTotalLabel;

            if (!customLabel) {
              customLabel = chart.customLabel =
                chart.renderer.label(
                  'Consignments'
                )
                  .css({
                    color: '#000',
                    textAnchor: 'middle'
                  })
                  .add();
            }

            if (!customTotalLabel) {
              customTotalLabel = chart.customTotalLabel =
                chart.renderer.label(
                  // totalCount
                )
                  .css({
                    color: '#000',
                    textAnchor: 'middle'
                  })
                  .add();
            }

            const x = series.center[0] + chart.plotLeft,
              y = series.center[1] + chart.plotTop - customLabel.attr('height') / 2;

            customLabel.attr({
              x,
              y
            });

            customTotalLabel.attr({
              x,
              y: y + 20
            });

            customLabel.css({
              fontSize: `${series.center[2] / 12}px`
            });

            customTotalLabel.css({
              fontSize: `${series.center[2] / 10}px`
            });
          }
        }
      },
      colors: colors,  // Make sure this is applied here
      accessibility: {
        point: {
          valueSuffix: ''
        }
      },
      title: {
        text: ''
      },
      subtitle: {
        text: ''
      },
      tooltip: {
        pointFormat: '{series.name}: {point.y:.0f} <b>({point.percentage:.0f}%)</b>'
      },
      legend: {
        enabled: false
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: false,
            distance: 20,
            format: '{point.name}'
          }
        }
      },
      series: [{
        name: 'Orders',
        colorByPoint: true,
        innerSize: '75%',
        size: "90%",
        data: this.state.series,
      }],
      credits: false
    });
};

  filterDatafordates = () => {
    // setloadshow('show-m')
    var from_date1 = this.state.from_date
    var to_date1 = this.state.end_date
    var from_date2 = this.state.from_date
    var to_date2 = this.state.end_date
    
    
    if (from_date1=="Invalid date"){
      from_date1 = '';
  }
  if (to_date1 =='Invalid date'){
      to_date1 = '';
  }
  
  if (from_date1 !=''){
      const dateObj = moment(from_date1, 'DD-MM-YYYY');
      const formattedFromDate = dateObj.toDate();
      from_date1= formattedFromDate;
  }
  if (to_date1 !=''){
      const dateObj = moment(to_date1, 'DD-MM-YYYY');
      const formattedFromDate = dateObj.toDate();
      to_date1= formattedFromDate;
  }
    if (from_date1 != '' && from_date1 != undefined && from_date1 != null && to_date1 != '' && to_date1 != undefined && to_date1 != null) {
        if (from_date1 <= to_date1) {
           this.getData(from_date2, to_date2)
            // setselectedData(filteredData)
            // setloadshow('show-n')

        }
          else{
            this.setState({
              basicTitle:'From Date sholud be less than To Date',
              basicType:'danger',
              overlay:'show-n',
              show:true
            })
             
          }
      }
      else {
        this.setState({
          basicTitle:'Please Select Start Date and End date',
          basicType:'danger',
          overlay:'show-n',
          show:true
        })
          
      }
  }  
  handleDatesSelected = (e) => {
    const date = moment(e).format('DD-MM-YYYY');
    this.setState({
      from_date: date
    })
};
handleDatesSelected1 = (e) => {
  const date = moment(e).format('DD-MM-YYYY');
  this.setState({
    end_date: date
  })
};
render() {
  
  return (
    <div className="card-header2">
      <div className='d-flex justify-content-between'>
                    <h1 className='heading3 mt-20p ml-5p' style={{ width: "240px" }}>% Shipment under breach bucket calculation</h1>
              <div className='d-flex'>
                    
                    <div className="row">

                        <div className="form-group col-xl-4 col-lg-4">
                            <div>
                                <label className='dateStyling'> From Date </label>
                                <Datetime
                                    className='smaller-datetime'
                                    key={this.state.from_date}
                                    // onKeyDown ={(e)=> restrictToOther(e)}
                                    placeholder="Date"
                                    disableCloseOnClickOutside={false}
                                    closeOnSelect={true}
                                    name="from_date"
                                    inputProps={{ readOnly: 'true' }}
                                    value={this.state.from_date}
                                    dateFormat="DD-MM-YYYY"
                                    id='from_date'
                                    timeFormat={false}
                                    onChange={(e) => this.handleDatesSelected(e)}
                                    required />
                            </div>
                        </div>
                        <div className="form-group col-xl-4 col-lg-4">
                            <div>
                                <label className='dateStyling'> To Date </label>
                                <Datetime
                                    className='smaller-datetime'
                                    key={this.state.end_date}
                                    placeholder="Date"
                                    disableCloseOnClickOutside={false}
                                    closeOnSelect={true}
                                    name="to_date"
                                    inputProps={{ readOnly: 'true' }}
                                    value={this.state.end_date}
                                    dateFormat="DD-MM-YYYY"
                                    id='to_date'
                                    timeFormat={false}
                                    onChange={(e) => this.handleDatesSelected1(e)}
                                    required />
                            </div>
                        </div>
                        <div className="form-group col-xl-4 col-lg-4">
                            <button className="custom-btn1 f10 label label-success mt-30p" onClick={this.filterDatafordates}>Submit</button>
                        </div>
                    </div>
                </div>
    </div>
        <div className="d-flex flex-row justify-content-between align-items-center leFadeInLeft w-100 pr-1">
        <div className='col-sm-6'>
           <div id="container-c" style={{ height: '300px', width: '100%', margin: '0 auto' }}></div>
        </div>

          <div className='col-sm-6'>
            <div className="d-flex flex-column justify-content-center leFadeInLeft pl-3 pr-4 mr-4 donut-content-sec" style={{marginBottom:'2rem'}}>
              <ul className="chart-info" style={{marginTop:"0px"}}>
              {/* <li className="pb-2 d-flex flex-row justify-content-between align-items-center cursor-pointer" style={{ color: colors[0],cursor:'pointer', fontSize:"0.9rem" }} onClick={() => window.location.href = "dipatchplanhistory?"+'Total'}>
                  Total
                  <span>{this.state.totalCount}</span>
                </li > */}
                <li className="py-2 d-flex flex-row justify-content-between align-items-center cursor-pointer" style={{ color: colors[0],cursor:'pointer', fontSize:"0.9rem" }} onClick={() => window.location.href = "dipatchplanhistory?"+'Total'}>
                  No
                  <span>{this.state.noBreach}</span>
                </li >
                <li className="py-2 d-flex flex-row justify-content-between align-items-center cursor-pointer" style={{ color: colors[1],cursor:'pointer', fontSize:"0.9rem" }} onClick={() => window.location.href = "dipatchplanhistory?"+'Active'}>
                  1-2 days
                  <span>{this.state.oneToTwoDaysBreach}</span>
                </li>
                <li className="py-2 d-flex flex-row justify-content-between align-items-center cursor-pointer" style={{ color: colors[2],cursor:'pointer', fontSize:"0.9rem" }} onClick={() => window.location.href = "dipatchplanhistory?"+'Delivered'}>
                  3-5 days
                  <span>{this.state.threeToFiveDaysBreach}</span>
                </li>
                <li className="py-2 d-flex flex-row justify-content-between align-items-center cursor-pointer" style={{ color: colors[3],cursor:'pointer', fontSize:"0.9rem" }} onClick={() => window.location.href = "dipatchplanhistory?"+'Epod'}>
                  6-10 days
                  <span>{this.state.sixToTenDaysBreach}</span>
                </li>
                <li className="py-2 d-flex flex-row justify-content-between align-items-center cursor-pointer" style={{ color: colors[4],cursor:'pointer', fontSize:"0.9rem" }} onClick={() => window.location.href = "dipatchplanhistory?"+'Epod'}>
                &gt;10 days
                  <span>{this.state.greaterTenDaysBreach}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        
    </div>
  );
}
}


function formatDate(dateString) {
  // Split the date string into components
  const parts = dateString.split('-');
  const day = parts[0];
  const month = parts[1];
  const year = parts[2];

  // Reformat the date string
  const newDateString = `${year}-${month}-${day}`;
  return newDateString;
}


export default ConsignmentChart;
